module.exports = __webpack_public_path__ + "cancellara-dist/img/autogrill.d72824be.png";